import React from "react";
import "./HomeDetails.css";

function BedroomPrices() {
  // const bedprices = [];
  // for (let bname in bedroom_prices) {
  //     bedprices.push({name: bname, price: bedroom_prices[bname]})
  // }

  return <div>BedroomPrices</div>;
}

export default BedroomPrices;
